import React, { useEffect } from "react";
import styled from 'styled-components';
import Header from '../components/common/header/Header';
import { useDispatch } from "react-redux";
import { setHeaderTransferAction, setCurMenuAction } from "../modules/common/headerModule";
import HpMainBanner from "../components/hp/HpMainBanner";
import Footer from "../components/common/Footer";
import HpMiddleGuide from "../components/hp/HpMiddleGuide";
import HpCateItems from "../components/hp/HpCateItems";
import HpSpaceTour from "../components/hp/HpSpaceTour";
import HpBrandList from "../components/hp/HpBrandList";
import HpProdList from "../components/hp/HpProdList";
import { isIE, isChrome, isMobileOnly } from "react-device-detect";
import HpMainBannerNew from "../components/hp/HpMainBannerNew";
import HpPopUpMobileContainer from "../components/hp/HpPopUpMobileContainer";

const HomeBlock = styled.div`
margin:0 auto;
`;

const MobileMarginBlock = styled.div`
  //${isMobileOnly&&"margin:0 4vw;"}
`;
const Home = () => {

    const dispatch = useDispatch();

    // 최소 실행시 Header 관련 처리 추가
    useEffect(() => {
        dispatch(setCurMenuAction('main'));
        dispatch(setHeaderTransferAction(true));

        // if (isChrome === false) {
        //     // alert("어디가구는 크롬 PC 화면에 최적화 되어있습니다.")
        // }
      /* if (isIE) {
        alert("어디가구는 크롬 브라우저에 최적화되어 있으며, 인터넷 익스플로러에서는 정상적으로 동작하지 않을 수 있음을 양해 부탁드립니다.")
      } */


    }, [])

    return (
        <HomeBlock>
            <Header />
            <HpMainBannerNew />
            <MobileMarginBlock>
              <HpCateItems />
              <HpBrandList />
              <HpProdList />
            </MobileMarginBlock>
            {isMobileOnly&&<HpPopUpMobileContainer/>}
            {/* <HpSpaceTour /> */}
            <HpMiddleGuide />
          <Footer />
        </HomeBlock>
    );
};

export default Home;
